import { FC, useCallback, useMemo } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import { DistributionType, ShareAmount } from "@/services/cloudchipr.api";
import { DimensionCostAllocationCardSharedAmountsTableManualRow } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/cost-allocation-card/components/shared-amounts-table/DimensionCostAllocationCardSharedAmountsTableManualRow";
import { updateSharedCost } from "@/store/dimensions/dimensionsSlice";
import { useAppDispatch } from "@/store/hooks";
import { DimensionCostAllocationCardSharedAmountsTableEvenBody } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/cost-allocation-card/components/shared-amounts-table/DimensionCostAllocationCardSharedAmountsTableEvenBody";

interface DimensionCostAllocationCardSharedAmountsTableProps {
  distributionType: DistributionType;
  shareAmounts: ShareAmount[];
  sharedCostId: string;
}

export const DimensionCostAllocationCardSharedAmountsTable: FC<
  DimensionCostAllocationCardSharedAmountsTableProps
> = ({ shareAmounts, distributionType, sharedCostId }) => {
  const dispatch = useAppDispatch();

  const amountsSum = useMemo(() => {
    return shareAmounts.reduce(
      (sum, { share_amount }) => sum + share_amount,
      0,
    );
  }, [shareAmounts]);

  const amountChangeHandler = useCallback(
    (categoryId: string, shareAmount: number) => {
      dispatch(
        updateSharedCost({
          id: sharedCostId,
          share_amounts: shareAmounts.map((amount) => {
            if (amount.category_id !== categoryId) {
              return amount;
            }

            return { ...amount, share_amount: shareAmount };
          }),
        }),
      );
    },
    [dispatch, shareAmounts, sharedCostId],
  );

  return (
    <TableContainer component={Paper} sx={tableContainerSx}>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
            <TableCell sx={{ fontWeight: "bold" }}>Category Name</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Allocation (%)</TableCell>
          </TableRow>
        </TableHead>

        {distributionType === "even" ? (
          <DimensionCostAllocationCardSharedAmountsTableEvenBody />
        ) : (
          <TableBody>
            {shareAmounts.map((shareAmount) => (
              <DimensionCostAllocationCardSharedAmountsTableManualRow
                shareAmount={shareAmount}
                amountsSum={amountsSum}
                key={shareAmount.category_id}
                onAmountChange={amountChangeHandler}
              />
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
};

const tableContainerSx = {
  borderRadius: 2,
  border: 1,
  borderBottom: 0,
  borderColor: "grey.300",
  overflow: "hidden",
};
